/**
 * Tailwind only emits classes it finds spelled out in source, so a
 * `z-[${n}]` built at runtime has no CSS once nothing else writes that tier
 * out. That is how the segment picker fell behind the Edit Automation dialog
 * (OC-1247): `z-[10000]` lost its last literal and the picker stacked under
 * the `z-[9999]` dialog that opened it. Spell each tier out here instead.
 *
 * A dialog opened from a dialog takes the same tier: it mounts later, so its
 * portal paints on top, and tooltips and menus at `z-[9999]` still clear it.
 */
export const DIALOG_Z_INDEX_CLASSNAMES = {
  9999: "z-[9999]",
} as const;

export type DialogZIndex = keyof typeof DIALOG_Z_INDEX_CLASSNAMES;
